import store from '../../store'
import GenericDataService from '@/services/GenericDataService'

export default [
    {
        path: '/statistics',
        meta: { breadCrumb: 'statistics', titleDocument: "statistics", subMenu: false},
        component: function () {
            return import(/* webpackChunkName: "form-operations" */ '../../modules/statistics/views/Statistics.vue')
        },
        beforeEnter: (to, from, next) => {
            GenericDataService.getData('/menu/getsubmenu?module=statistics').then((response) => {
                let submenu = response.data.data;
                store.dispatch('base/SET_SUB_MENU', submenu)
                next();
            })  
        },
        children: [
            {
                path: 'marketing',
                name: "StatisticsMarketing",
                meta: { title:'Statistics' },
                component: function () {
                    return import(/* webpackChunkName: "template" */ '../../modules/statistics/views/StatisticsMarketing.vue')
                }
            },
            {
                path: 'commerce',
                name: "StatisticsCommerce",
                meta: { title:'Statistics' },
                component: function () {
                    return import(/* webpackChunkName: "template" */ '../../modules/statistics/views/StatisticsCommerce.vue')
                }
            },
            {
                path: 'providers',
                name: "StatisticsProviders",
                meta: { title:'Statistics' },
                component: function () {
                    return import(/* webpackChunkName: "template" */ '../../modules/statistics/views/StatisticsProviders.vue')
                }
            }
        ]
    }
]